
import useCommonApi from "../../api/useCommonApi";
import { ClaveFraccionArancelariaActionTypes, ClaveFraccionArancelariaState, LOAD_FRACCIONARANCELARIA_SUCCESS } from "../types/claveFraccionArancelariaActionTypes";

const apiSource = useCommonApi();

function loadClaveFraccionArancelariaSuccess(clavesFraccionArancelaria: ClaveFraccionArancelariaState[]): ClaveFraccionArancelariaActionTypes {
    return {
        type: LOAD_FRACCIONARANCELARIA_SUCCESS,
        clavesFraccionArancelaria
    }
}

export function loadClaveFraccionArancelaria(clienteId:number) {
    return function (dispatch) {
        return apiSource.obtener<ClaveFraccionArancelariaState[]>("solicitud-servicio/get-catalogo-fraccion-arancelaria/"+clienteId)
            .then((clavesFraccionArancelaria: ClaveFraccionArancelariaState[]) => {
                dispatch(loadClaveFraccionArancelariaSuccess(clavesFraccionArancelaria))
            })
            .catch(error => {
                //throw error;
            })
    }
}
